module.exports = __webpack_public_path__ + "img/case31.4cceb730.png";